import {
  availableInEN,
  availableInDE,
  availableInES,
  availableInFR,
  availableInENPAM,
  availableInHU,
  availableInESP,
} from '@/components/shared/languageCodes';
import store from '@/store';

const getSessionTimeoutModalStatus = state => state.sessionTimeoutModalStatus;

const getIsSpecialUser = () => {
  const loggedInUser = store.getters['users/loggedInUserProfile'].user;
  const availableIdsProd = [
    5633216,
    3933496,
    2818687,
    815551,
    3208219,
    3018369,
    4839590,
    5481687,
    4227255,
    4081104,
    // T-P ->
    5492151,
    5556675,
    5078181,
  ];
  const availableIdsStage = [
    815551,
    3030004,
    3015937,
    3010414,
    // T-P ->
    3023647,
    3035353,
    3037570,
  ];
  const availableIdsTest = [
    3732811,
    3732934,
    3208219,
    3018369,
    3732805,
    3636961,
    3732998,
    // T-P ->
    2867883,
    3732730,
    3732841,
  ];
  if (process.env.IS_TEST == true || process.env.IS_TEST == 'true' || location.href.includes('test.')) {
    return availableIdsTest.includes(loggedInUser.id);
  }
  if (process.env.IS_STAGING == true || process.env.IS_STAGING == 'true' || process.env.NODE_ENV === 'development' || location.href.includes('staging.')) {
    return availableIdsStage.includes(loggedInUser.id);
  }
  if (process.env.NODE_ENV === 'production') {
    return availableIdsProd.includes(loggedInUser.id);
  }
  return false;
};

const getLanguages = () => {
  if (!store.getters.hasToken && store.getters['settings/getIsKHUser']) {
    return ['enpam', 'en', 'de', 'es', 'fr'];
  }
  if (store.getters['users/isKretaUser'] && store.getters['users/isKHUser']) {
    return ['enpam', 'en', 'de', 'es', 'fr'];
  } else if (store.getters['users/isKretaUser'] && store.getters['users/isNeptunUser']) {
    return ['en', 'de', 'es', 'fr', 'esp01bus', 'esp02med', 'esp03leg', 'esp04aca', 'esp05tou', 'esp06it', 'esp07tec', 'esp08cat', 'esp09eng', 'esp10vet', 'hu'];
  } else if (store.getters['users/isKretaUser']) {
    return ['en', 'de'];
  }
  return ['en', 'de', 'es', 'fr', 'esp01bus', 'esp02med', 'esp03leg', 'esp04aca', 'esp05tou', 'esp06it', 'esp07tec', 'esp08cat', 'esp09eng', 'esp10vet', 'hu'];
};

const getAllLanguages = () => {
  return ['en', 'de', 'es', 'fr', 'esp01bus', 'esp02med', 'esp03leg', 'esp04aca', 'esp05tou', 'esp06it', 'esp07tec', 'esp08cat', 'esp09eng', 'esp10vet', 'enpam', 'hu'];
};

// Deprecated ??
const getLanguageIds = (state, getters) => {
  const availableLanguages = getters.getLanguages;
  const LANGUAGE_IDS = [];

  availableLanguages.forEach((key, index) => {
    LANGUAGE_IDS[index + 1] = key;
  });

  return LANGUAGE_IDS;
};

const getLanguageCodes = (state, getters) => {
  const availableLanguages = getters.getAllLanguages;
  const LANGUAGE_CODES = [];

  availableLanguages.forEach((key, index) => {
    LANGUAGE_CODES[key] = store.getters['users/isKHUser'] ? index : index + 1;
  });

  return LANGUAGE_CODES;
};

const getMotherLanguages = (state, getters) => {
  const availableLanguages = getters.getLanguages;
  const MOTHER_LANGUAGES = {
    en: availableInEN,
    de: availableInDE,
    es: availableInES,
    fr: availableInFR,
    enpam: availableInENPAM,
    hu: availableInHU,
    esp01bus: availableInESP,
    esp02med: availableInESP,
    esp03leg: availableInESP,
    esp04aca: availableInESP,
    esp05tou: availableInESP,
    esp06it: availableInESP,
    esp07tec: availableInESP,
    esp08cat: availableInESP,
    esp09eng: availableInESP,
    esp10vet: availableInESP,
  };
  const AVAILABLE_MOTHER_LANGUAGES = [];

  availableLanguages.forEach((key) => {
    AVAILABLE_MOTHER_LANGUAGES[key] = MOTHER_LANGUAGES[key];
  });

  return AVAILABLE_MOTHER_LANGUAGES;
};

const getLanguageLevels = (state, getters) => {
  const availableLanguages = getters.getLanguages;

  // Need to minus 1 from the current level because we use 0 to index
  const LANGUAGE_LEVELS = {
    enpam: 2,
    en: 12,
    de: 6,
    es: 3,
    fr: 2,
    hu: 1,
    esp01bus: 2,
    esp02med: 3,
    esp03leg: 3,
    esp04aca: 2,
    esp05tou: 2,
    esp06it: 3,
    esp07tec: 3,
    esp08cat: 2,
    esp09eng: 2,
    esp10vet: 2,
  };
  const AVAILABLE_LANGUAGE_LEVELS = [];

  availableLanguages.forEach((key) => {
    AVAILABLE_LANGUAGE_LEVELS[key] = LANGUAGE_LEVELS[key];
  });

  return AVAILABLE_LANGUAGE_LEVELS;
};

export default {
  getSessionTimeoutModalStatus,
  getLanguages,
  getLanguageCodes,
  getLanguageIds,
  getAllLanguages,
  getMotherLanguages,
  getLanguageLevels,
  getIsSpecialUser,
};
